// eslint-disable-next-line jira/filename-case
import { createHook } from '../index.tsx';
import { getBlueprintsFlowTourDismissed } from './blueprints.tsx';

export const useBlueprintsTourDismissed: () => boolean | undefined = createHook(
	getBlueprintsFlowTourDismissed,
);
